import * as React from 'react';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import axios from 'axios';
import MessagebarContext from '../../../../context/MessagebarContext';
import Card from '../../../shared/Card';
import { Box, Flex } from '../../../shared/layouts';
import { useTranslation } from 'react-i18next';
import useIconLibrary from '../../../../hooks/useIconLibrary';
import { DashHeading } from '../DashboardPage';
import DashIcon from 'imagesUwKluis/svg/dual/dashboard.svg';

const ContactWidget = () => {
  const { t } = useTranslation();
  const { setAlertMessage } = useContext(MessagebarContext);
  const { MessageIcon, ContactIcon } = useIconLibrary();

  const { data: contactPerson } = useQuery(
    'contactInformation',
    async () => {
      try {
        const {
          data: { contactInformation }
        } = await axios('/contact-information');
        // Look for people
        const contactPeople = contactInformation?.contact_persons;
        if (contactPeople && contactPeople?.length > 0) {
          const featuredPerson = contactPeople.find(
            ({ featured_contact }) => featured_contact
          );
          return featuredPerson || contactPeople[0];
        }
        // Fallback to location
        const contactLocations = contactInformation?.locations;
        if (contactLocations[0]) return contactLocations[0]

        return null;
      } catch (error) {
        setAlertMessage();
      }
    },
    { refetchOnWindowFocus: false, retry: false }
  );

  if (!contactPerson || !contactPerson?.name) return null;

  return (
    <div>
      <DashHeading>{t('Jouw adviseur')}</DashHeading>
      <Card bg={'alertHover'}>
        <Flex alignItems={'center'}>
          {contactPerson?.photo ? (
            <Box flexShink={0}>
              <img
                src={'data:image/png;base64,' + contactPerson?.photo}
                alt={t('{{name}} profiel foto', {
                  name: contactPerson?.name
                })}
                height={'72'}
                width={'72'}
                css={({ space }) => ({
                  display: 'block',
                  marginRight: space.m,
                  objectFit: 'cover',
                  objectPosition: 'center',
                  overflow: 'hidden',
                  borderRadius: '8px'
                })}
              />
            </Box>
          ) : (
            <DashIcon
              height={'72px'}
              width={'72px'}
              css={({ space }) => ({ marginRight: space.m })}
            />
          )}
          <Flex
            flexGrow={1}
            flexWrap={'wrap'}
            justifyContent={'space-between'}
            alignItems={'center'}
          >
            <Box>
              <Box
                fontScale={'l'}
                fontWeight={'bold'}
                css={{ textDecoration: 'underline' }}
              >
                {contactPerson?.name}
              </Box>
              <Box>{contactPerson?.role || 'Service & Contact'}</Box>
            </Box>
            <Flex
              mt={'s'}
              css={({ space, colors }) => ({
                '> * + *': { marginLeft: space.l },
                svg: { fill: colors?.primaryFont },
                'a:hover > svg': { fill: colors?.primary }
              })}
            >
              {contactPerson?.email && (
                <a
                  href={`mailto:${contactPerson?.email}`}
                  target={'_blank'}
                  rel={'noreferrer'}
                >
                  <MessageIcon height="2rem" width="2rem" />
                </a>
              )}
              {contactPerson?.phone && (
                <a
                  href={`tel:${contactPerson?.phone}`}
                  target={'_blank'}
                  rel={'noreferrer'}
                >
                  <ContactIcon height="2rem" width="2rem" />
                </a>
              )}
            </Flex>
          </Flex>
        </Flex>
      </Card>
    </div>
  );
};

export default ContactWidget;
